import React, { FunctionComponent } from 'react';
import Separator from '../separator';
import ReadOnlyText from '../read-only-text';

interface ReadOnlyFooterProps {
  text: string | React.ReactNode;
}

const ReadOnlyFooter: FunctionComponent<ReadOnlyFooterProps> = (props) => {
  const { text } = props;
  return (
    <>
      <Separator fullWidth={true} />
      <ReadOnlyText text={text}></ReadOnlyText>
    </>
  );
};

export default ReadOnlyFooter;
